module.exports = __webpack_public_path__ + "static/media/folder-open.df474ba4.svg";